import { Divider as AntdDivider, type DividerProps } from 'antd'
import styled from 'styled-components'

const StyledDivider = styled(AntdDivider)`
  margin: 0px;
`

const Divider = (props: DividerProps) => <StyledDivider {...props} />

export default Divider
